export default __webpack_public_path__ + "locales/sr-Latn-RS/Settings.json?hash=3b3733f5c9fe13cc55071ebd491a75ce";